import { Card, CardBody } from "reactstrap";

function StatCard({ icon, iconBg, value, label, change, changeUp }) {
  return (
    <Card className="sales-stat-card h-100">
      <CardBody className="d-flex align-items-start gap-3">
        <div className="sales-stat-icon" style={{ background: iconBg }}>
          {icon}
        </div>
        <div>
          <div className="sales-stat-value">{value}</div>
          <div className="sales-stat-label">{label}</div>
        </div>
      </CardBody>
    </Card>
  );
}

export default StatCard;